import PropTypes from 'prop-types';
import React from 'react';

class MarkerBlip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showInfo: false };
  }

  onMouseEnter = () => {
    this.setState({ showInfo: true });
  }

  onMouseLeave = () => {
    this.setState({ showInfo: false });
  }

  render() {
    // console.log('MarkerBlip ', this.props);
    let icon = (
      <span className="fa-stack fa-lg">
        <i className="fa fa-square fa-stack-2x"></i>
        <i className="fa fa-stack-1x fa-map-marker fa-inverse"></i>
      </span>
    );
    let name = 'unknown';
    if (this.props.place) {
      name = this.props.place.name;

      icon = (
        <span className="fa-stack fa-lg">
          <i className="fa fa-square fa-stack-2x" />
          <i className="fa fa-stack-1x fa-building fa-inverse" />
        </span>);
    } else {
      name = this.props.name;
    }
    return (
      <div>
        <div
          onMouseEnter={this.onMouseEnter}
          onMouseLeave={this.onMouseLeave}
        >
          {icon}
        </div>
        { this.state.showInfo &&
          <div
            style={{
              backgroundColor: '#EDEDED',
              border: '1px solid #777',
              width: 150,
              height: 70,
              padding: 10,
              position: 'relative',
              zIndex: 9999,
            }}
          >
            <h4 style={{ margin: 0 }}>{name}</h4>
          </div>
        }
      </div>
    );
  }
}

// HotelMap.propTypes = {
//   hotels: PropTypes.arrayOf(PropTypes.object).isRequired,
//   eventId: PropTypes.number.isRequired,
//   selectHotel: PropTypes.func.isRequired,
//   favoriteHotel: PropTypes.func.isRequired,
// };

export default MarkerBlip;



// WEBPACK FOOTER //
// src/routes/tours/components/MarkerBlip.js